import PricesTabs from "./prices-tabs.container";

export default PricesTabs;